import { render } from "./loading_animation.vue?vue&type=template&id=a8b6e64c&scoped=true"
import script from "./loading_animation.vue?vue&type=script&lang=js"
export * from "./loading_animation.vue?vue&type=script&lang=js"

import "./loading_animation.vue?vue&type=style&index=0&id=a8b6e64c&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b6e64c"]])

export default __exports__